import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/lib/site";
import { Reveal } from "@/components/motion-primitives";
import { PageHero, CtaButton, CtaBand, SectionHead, usePageMeta } from "@/components/shared";

export default function Services() {
  usePageMeta("Services", "Vacation rental management, Airbnb co-hosting, cleaning, inspections and maintenance coordination for Bermuda homeowners.");
  return (
    <main>
      <PageHero
        overline="Our Services"
        lines={["Complete Care for", "Bermuda Properties."]}
        copy="Every service below is delivered by a local team that treats your home as a hospitality asset — not a checklist. Combine them, or begin with the one you need most."
      >
        <CtaButton to="/assessment" variant="accent" testid="services-hero-assessment-btn">Get a Property Assessment</CtaButton>
      </PageHero>

      <section className="mx-auto max-w-[1440px] px-6 py-24 lg:px-10 lg:py-32">
        <SectionHead
          overline="The Full Spectrum"
          title="Twelve services. One accountable partner."
          copy="Each service opens into its own detailed page — what is included, how it works and what it means for you as an owner."
        />
        <div className="mt-16 grid gap-10 md:grid-cols-2">
          {SERVICES.map((s, i) => (
            <Reveal key={s.slug} delay={(i % 2) * 0.08}>
              <Link to={s.path} data-testid={`services-page-card-${s.slug}`} className="group block border border-navy/10 bg-white transition-all duration-500 hover:border-bermuda hover:shadow-2xl hover:shadow-navy/10">
                <div className="img-frame h-64 overflow-hidden sm:h-72">
                  <img src={s.image} alt={s.title} className="h-full w-full object-cover" loading="lazy" />
                </div>
                <div className="p-8 lg:p-10">
                  <div className="flex items-start justify-between gap-4">
                    <h3 className="font-serif text-2xl text-navy">{s.title}</h3>
                    <span className="mt-1 flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-navy/15 text-navy transition-all duration-300 group-hover:border-bermuda group-hover:bg-bermuda group-hover:text-navy">
                      <ArrowUpRight size={15} />
                    </span>
                  </div>
                  <p className="mt-3 text-sm leading-relaxed text-navy/60">{s.short}</p>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>

      <CtaBand copy="Not sure which services fit your property? A short conversation will make it obvious." />
    </main>
  );
}
